// @ts-nocheck
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export const ellipsis = (width = pxToRem(250)) => {
    return css`
        max-width: ${width};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    `;
};
